module.exports = __webpack_public_path__ + "static/media/beianbgs.a1ba0f22.png";